<template>
  <BreadCrumb PageTitle="Documentation API – Changement de statut" />
  <DriverStatusApiDocs>
    <template #intro>
      <div v-if="access && access.driver_code" class="dsa-token dsa-token--ok" role="note">
        <i class="ph ph-key" aria-hidden="true"></i>
        <span>Votre <code>driver-code</code> est <code>{{ access.driver_code }}</code> (le même que chez Kargo).</span>
      </div>
      <div v-if="access" class="dsa-token" :class="access.has_token ? 'dsa-token--ok' : 'dsa-token--none'" role="note">
        <i :class="access.has_token ? 'ph ph-key' : 'ph ph-info'" aria-hidden="true"></i>
        <span v-if="access.has_token">
          Votre token JSON (format natif) est actif (<code>sdl_••••{{ access.token_hint }}</code>, créé le {{ formatDate(access.token_created_at) }}<template
            v-if="access.last_used_at"
            >, dernière utilisation le {{ formatDate(access.last_used_at) }}</template
          >). Il n'est jamais réaffiché : en cas de perte, demandez-en un nouveau à l'administrateur.
        </span>
        <span v-else>Aucun token JSON n'a été généré pour votre compte (inutile pour le format Kargo).</span>
      </div>
    </template>
  </DriverStatusApiDocs>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import moment from "moment";
import api from "@/utils/axios";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DriverStatusApiDocs from "../../components/DriverStatusApi/DriverStatusApiDocs.vue";

interface Access {
  enabled: boolean;
  driver_code?: string | null;
  has_token: boolean;
  token_hint: string | null;
  token_created_at: string | null;
  last_used_at: string | null;
}

export default defineComponent({
  name: "DriverStatusApiDocsPage",
  components: {
    BreadCrumb,
    DriverStatusApiDocs,
  },
  setup() {
    const access = ref<Access | null>(null);

    onMounted(async () => {
      try {
        const res = await api.get("/api/auth/driver-status-api/access");
        access.value = res.data.enabled ? res.data : null;
      } catch {
        access.value = null;
      }
    });

    const formatDate = (value: string | null) => (value ? moment(value).format("DD/MM/YYYY HH:mm") : "—");

    return { access, formatDate };
  },
});
</script>

<style scoped>
.dsa-token {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-top: var(--ui-space-2);
  padding: 10px 12px;
  border-radius: var(--ui-radius-md);
  font-size: var(--ui-fs-sm);
  color: var(--ui-text);
}
.dsa-token i {
  font-size: 18px;
}
.dsa-token--ok {
  background: var(--ui-success-soft);
}
.dsa-token--none {
  background: var(--ui-info-soft, var(--ui-accent-soft));
}
</style>
